module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardColor
  }, [_c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.cardIcon
    }]
  }, [_c('span', [(_vm.cardIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.cardIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "bar-color": _vm.barColor,
      "chart-data": _vm.chartData,
      "chart-height": _vm.chartHeight,
      "chart-type": _vm.chartType,
      "label-prefix": _vm.labelPrefix,
      "legend-color": _vm.legendColor,
      "legend-link": _vm.legendLink,
      "show-legend": _vm.showLegend,
      "stacked": _vm.stacked,
      "x-max-axes-rotation": _vm.xMaxAxesRotation,
      "x-min-axes-rotation": _vm.xMinAxesRotation
    }
  }), _vm._v(" "), _c('table', {
    class: _vm.tableColor
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData.amounts), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.count).toLocaleString('en-US')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(data.percent).toLocaleString('en-US', {
      maximumFractionDigits: 2
    })) + "%")]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(Number(data.amount).toLocaleString('en-US')))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "highlight",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "highlight"
  }, [_vm._v("$" + _vm._s(Number(_vm.tableData.total).toLocaleString('en-US')))])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Severity")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("% of Cost")]), _vm._v(" "), _c('th', [_vm._v("Cost")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b77e3fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/barCharts/DamageCosts.vue
// module id = 438
// module chunks = 1